export const getList = () => {
    return {
        type: 'LIST_LOGISTICS_RESOURCE',
    };
};

export const setResources = (list) => {
    return {
        type: 'UPDATE_LOGISTICS_RESOURCE',
        list,
    };
};
